import { Component, inject, input } from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';

import { ButtonModule, IconModule } from '@hglobal/common';
import { TranslateModule } from '@ngx-translate/core';
import { ChatMessageReaction } from '@fb/models';
import { TranslateInPipe } from '@fb/pipes/translate-in.pipe';

import { AiChatStore } from '../../store';

@Component({
  selector: 'message-reaction',
  templateUrl: 'message-reaction.component.html',
  styleUrl: 'message-reaction.component.scss',
  imports: [
    NgTemplateOutlet,
    ButtonModule,
    IconModule,
    TranslateModule,
    NgClass,
    TranslateInPipe,
  ],
})
export class MessageReactionComponent {
  #aiChatStore = inject(AiChatStore);

  messageId = input.required<string>();
  reaction = input<ChatMessageReaction>();
  feedbackProvided = input<boolean>();

  chatMessageReaction = ChatMessageReaction;

  openFeedbackForm() {
    this.#aiChatStore.openFeedbackForm(this.messageId());
  }

  toggleReaction(reaction: ChatMessageReaction) {
    const next =
      this.reaction() === reaction ? ChatMessageReaction.none : reaction;

    this.#aiChatStore.toggleReaction({ id: this.messageId(), reaction: next });
  }
}
